module.exports = __webpack_public_path__ + "static/media/Document5.3bc05890.png";